import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDecks } from '../Decks/actions';
import { selectDecksByRelease } from '../Decks/selectors';
import { selectAllCards } from '../Cards/selectors';
import { getAllCards } from '../Cards/actions';
import { Muted } from '../Controls';
import { Page, PageTitle } from '../Page';
import { DeckPanel, useDeckZooms } from './DeckPanel';

/**
 * Every deck as sold, in the order they came out, each with its box (front and back; tap to see it big) and every card
 * in it. One whose cards aren't all playable yet is dimmed and can't be chosen for a game.
 */
const DecksPage = () => {
  const dispatch = useDispatch();
  const decks = useSelector(selectDecksByRelease);
  // Every card of every set: a deck that isn't playable yet holds cards that aren't either.
  const allCards = useSelector(selectAllCards);
  const cardsLoaded = !!allCards;
  const cardsById = allCards;
  const { onCard, onBox, zooms } = useDeckZooms();

  useEffect(() => {
    dispatch(getDecks());
    dispatch(getAllCards());
  }, [dispatch]);

  return (
    <Page $wide>
      <PageTitle>Decks</PageTitle>
      {(!decks.size || !cardsLoaded) && <Muted>Loading the decks…</Muted>}
      {cardsLoaded && decks.map(deck => (
        <DeckPanel key={deck.get('id')} deck={deck} cardsById={cardsById} onCard={onCard} onBox={onBox} />
      ))}
      {zooms}
    </Page>
  );
};

export default DecksPage;
